import React from 'react';

const RecipeProductModal = props => (
  <div className="modal fade" id="ingredient-modal" tabIndex="-1" role="dialog" aria-labelledby="ingredient-modal-label" aria-hidden="true">
    <div className="modal-dialog modal-lg" role="document">
      <div className="modal-content">
        <a className="close-modal" href="_#" data-dismiss="modal" aria-label="Close">x</a>
        <div className="modal-header">
          <h5 className="modal-title text-center" id="recipe-modal-label">Product Details</h5>
        </div>

        <div className="modal-body">
          <div className="row">
            <div className="modal-product-images col-lg-4">
              <div className="modal-current-image">
              {
                props.product.image_path ? <img id="main-product-image" src={`${props.product.image_path}`} alt="" /> : null
              }
              </div>
              <div className="modal-slides-image">
                <div className="row">
                  <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12 center">
                    <ul>
                      <li>
                        {
                          props.product.image_path ? <a href="_blank" className="show-modal-thumbnail" onClick={() => props.changeModalImage(props.product.image_path)}><img src={`${props.product.image_path}`} alt="" /></a> : null
                        }
                      </li>
                      <li>
                        {
                          props.product.nutrition ? <a href="_blank" className="show-modal-thumbnail" onClick={() => props.changeModalImage(props.product.nutrition)}><img src={`${props.product.nutrition}`} alt="" /></a> : null
                        }
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-lg-7">
              <div className="product-desc-title">
                <div className="row">
                  <div className="col-lg-12">

                    {
                      props.product.name ? <h5 className="recipe-modal-title">{props.product.name} <p className="product-tag">{props.product.feature_tag}</p> </h5> : null
                    }
                  </div>
                </div>
              </div>
              <div className="product-desc semibold">
                {
                  props.product.sku ? <p>SKU: {props.product.sku}<br/> Category: {props.product.category}<br/> Product Sizes: {props.product.product_sizes}</p> : null
                }
                {
                  props.product.productofthemonth ? <p style={{fontSize: 16}}><br/><br/>{props.product.productofthemonth.description}</p> : null
                }
              </div>
            </div>
            <div className="col-lg-1"></div>
          </div>

          <div className="row modal-recipes">
            <div className="associated-recipes col-lg-12 semibold">
              <p>Associated Recipes</p>
              <div className="modal-recipes-list text-center">
              {
                props.product.recipes ? <div className="row">{
        	        props.product.recipes.map((recipe, index) => {
                    return <div className="col-lg-3 col-sm-3"><a onClick={() => props.setRecipeModal(recipe.recipe_id)} className="secondary-a" href="_#" data-toggle="modal" data-target="#recipe-modal" data-dismiss="modal"><div className="modal-recipe-item" style={{backgroundImage: "url(" + recipe.image_path + ")"}}></div><p>{recipe.name}</p></a></div>; })
        	      }</div> : null
              }
              </div>
            </div>
          </div>
        </div>

      </div>
    </div>
  </div>
);

export default RecipeProductModal;
